"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _Headlight = _interopRequireDefault(require("./Headlight.js"));
var _SurveyModalContents = _interopRequireDefault(require("../ModalContents/SurveyModalContents.js"));
var _FlowModalContents = _interopRequireDefault(require("../ModalContents/FlowModalContents.js"));
var _JsonEditorModalContents = _interopRequireDefault(require("../ModalContents/JsonEditorModalContents.js"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _boxAdd = _interopRequireDefault(require("cccisd-icons/box-add"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _boxRemove = _interopRequireDefault(require("cccisd-icons/box-remove"));
var _broom = _interopRequireDefault(require("cccisd-icons/broom"));
var _arrowResize = _interopRequireDefault(require("cccisd-icons/svg/arrow-resize4"));
var _podcast = _interopRequireDefault(require("cccisd-icons/svg/podcast"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _admin = require("../../reducers/admin.js");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _HighlightWord = _interopRequireDefault(require("../HighlightWord"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _composeErrorMessage = _interopRequireDefault(require("../../helpers/composeErrorMessage.js"));
var _styleSurveycard = _interopRequireDefault(require("./style-surveycard.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var SurveyCard = /*#__PURE__*/function (_React$Component) {
  function SurveyCard() {
    var _this;
    _classCallCheck(this, SurveyCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SurveyCard, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false
    });
    _defineProperty(_this, "archiveSurvey", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var surveyData, message, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            surveyData = _this.props.surveyData;
            _this.setState({
              loading: true
            });
            _context.p = 1;
            _context.n = 2;
            return _this.props.archiveSurvey(surveyData.surveyId);
          case 2:
            (0, _cccisdNotification["default"])('Survey successfully archived');
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            message = function (_e$deployment) {
              var deploymentCount = (_t === null || _t === void 0 ? void 0 : (_e$deployment = _t.deployment) === null || _e$deployment === void 0 ? void 0 : _e$deployment.length) || 0;
              if (deploymentCount > 0) {
                return "Survey is part of ".concat(deploymentCount === 1 ? 'an active deployment' : 'active deployments:', " ").concat(_t.deployment.map(function (item) {
                  return "\"".concat(item.modelLabel, "\"");
                }).join(', '));
              }
              return 'Survey failed to archive';
            }();
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: message,
              duration: 0
            });
            _this.setState({
              loading: false
            });
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    })));
    _defineProperty(_this, "unarchiveSurvey", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var surveyData, isSuccess;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            surveyData = _this.props.surveyData;
            _this.setState({
              loading: true
            });
            _context2.n = 1;
            return _this.props.unarchiveSurvey(surveyData.surveyId);
          case 1:
            isSuccess = _context2.v;
            if (isSuccess) {
              (0, _cccisdNotification["default"])('Survey successfully unarchived');
            } else {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: 'Survey failed to unarchive'
              });
              _this.setState({
                loading: false
              });
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "deleteSurvey", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(surveyToDeleteId) {
        var surveyData, message, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              surveyData = _this.props.surveyData;
              _this.setState({
                loading: true
              });
              _context3.p = 1;
              _context3.n = 2;
              return _this.props.deleteSurvey(surveyData.surveyId);
            case 2:
              (0, _cccisdNotification["default"])('Survey successfully deleted');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              message = function (_e$deployment2) {
                var deploymentCount = (_t2 === null || _t2 === void 0 ? void 0 : (_e$deployment2 = _t2.deployment) === null || _e$deployment2 === void 0 ? void 0 : _e$deployment2.length) || 0;
                if (deploymentCount > 0) {
                  return "Survey is part of ".concat(deploymentCount === 1 ? 'an active deployment' : 'active deployments:', " ").concat(_t2.deployment.map(function (item) {
                    return "\"".concat(item.modelLabel, "\"");
                  }).join(', '));
                }
                return 'Survey failed to delete';
              }();
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: message,
                duration: 0
              });
              _this.setState({
                loading: false
              });
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 3]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onUpdateSurvey", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(values) {
        var surveyId, isSuccess, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              surveyId = _this.props.surveyData.surveyId;
              _context4.p = 1;
              _context4.n = 2;
              return _this.props.updateSurvey(surveyId, _objectSpread(_objectSpread({}, _this.props.surveyData.settings), values));
            case 2:
              isSuccess = _context4.v;
              if (isSuccess) {
                (0, _cccisdNotification["default"])("Survey \"".concat(values.title, "\" successfully updated"));
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: 'Survey failed to update'
                });
              }
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              return _context4.a(2, Promise.reject(_t3));
            case 4:
              _this.editSurveyModal.close();
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "deleteFlow", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(language, flowData) {
        var _this$props, assignment, surveyData, hasManyLanguages, description, process;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this$props = _this.props, assignment = _this$props.assignment, surveyData = _this$props.surveyData;
              hasManyLanguages = assignment.settings.buildLanguages.length > 1;
              description = hasManyLanguages ? "Are you sure you want to delete ".concat(_this.getLanguageNameFromTwoLetterCode(language), " version of \"").concat(surveyData.label, "\" survey?") : "Are you sure you want to delete \"".concat(surveyData.label, "\" survey?");
              process = /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                  var _t4;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.p = _context5.n) {
                      case 0:
                        _this.setState({
                          loading: true
                        });
                        _context5.p = 1;
                        _context5.n = 2;
                        return _this.props.deleteFlow(flowData.flowId);
                      case 2:
                        (0, _cccisdNotification["default"])('Flow successfully deleted');
                        _context5.n = 4;
                        break;
                      case 3:
                        _context5.p = 3;
                        _t4 = _context5.v;
                        (0, _cccisdNotification["default"])({
                          type: 'danger',
                          message: 'Survey failed to delete',
                          duration: 0
                        });
                      case 4:
                        _this.setState({
                          loading: false
                        });
                      case 5:
                        return _context5.a(2);
                    }
                  }, _callee5, null, [[1, 3]]);
                }));
                return function process() {
                  return _ref6.apply(this, arguments);
                };
              }();
              (0, _cccisdConfirm["default"])({
                message: 'Confirm delete?',
                description: description,
                confirmLabel: 'Yes',
                abortLabel: 'Cancel'
              }).then(process);
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    // render the headlight actions
    _defineProperty(_this, "_renderHeadlight", function () {
      var _this$props2 = _this.props,
        assignmentTerm = _this$props2.assignmentTerm,
        assignment = _this$props2.assignment,
        project = _this$props2.project,
        surveyData = _this$props2.surveyData;
      var isSurveyDeployed = function () {
        var surveyFlowHandles = new Set((surveyData.flowList || []).map(function (flow) {
          return flow.flowHandle;
        }));
        return assignment.deploymentList.some(function (deployment) {
          return deployment.isOpen && deployment.settings.options.some(function (handle) {
            return surveyFlowHandles.has(handle);
          });
        });
      }();
      var deleteSurveyButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-xs btn-danger",
        "data-delete-survey-button": surveyData.surveyId,
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm delete?',
            description: "Are you sure you want to delete Survey '" + surveyData.label + "'?",
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(_this.deleteSurvey);
        },
        disabled: isSurveyDeployed
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));

      // archived survey headlight
      if (!surveyData.archived) {
        // display text to identify assignment and project names
        var assignmentProjectStr = "For Survey \"".concat(surveyData.label, "\", ").concat(assignmentTerm, " \"").concat(assignment.label, "\"");
        if (project.label !== '') {
          assignmentProjectStr += ' in Quest Project "' + project.label + '"';
        }

        // normal headlight
        return /*#__PURE__*/_react["default"].createElement(_Headlight["default"], null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Edit Survey"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            "data-edit-survey-button": surveyData.surveyId,
            className: "btn btn-xs btn-success"
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
          title: "Edit Survey",
          ref: function ref(elem) {
            _this.editSurveyModal = elem;
          }
        }, /*#__PURE__*/_react["default"].createElement(_SurveyModalContents["default"], {
          assignmentProjectStr: assignmentProjectStr,
          initialValues: {
            title: surveyData.label,
            subtitle: surveyData.description,
            isRequired: 'isRequired' in surveyData.settings ? surveyData.settings.isRequired : true
          },
          onSubmit: _this.onUpdateSurvey
        })), (Fortress.user.acting.user.auth_type === 'ldap' || !!Fortress.user.acting.is_super_user) && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Settings JSON Editor"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            "data-edit-json-button": surveyData.surveyId,
            className: "btn btn-xs btn-warning"
          }, /*#__PURE__*/_react["default"].createElement(_broom["default"], null))),
          title: "Settings JSON Editor",
          size: "large"
        }, /*#__PURE__*/_react["default"].createElement(_JsonEditorModalContents["default"], {
          assignmentProjectStr: assignmentProjectStr,
          surveyData: surveyData
        })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Archive"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-xs btn-primary",
          "data-archive-survey-button": surveyData.surveyId,
          onClick: function onClick() {
            (0, _cccisdConfirm["default"])({
              message: 'Confirm archive?',
              description: "Are you sure you want to archive Survey '" + surveyData.label + "'?",
              confirmLabel: 'Yes',
              abortLabel: 'Cancel'
            }).then(_this.archiveSurvey);
          },
          disabled: isSurveyDeployed
        }, /*#__PURE__*/_react["default"].createElement(_boxAdd["default"], null)))), /*#__PURE__*/_react["default"].createElement("span", null, deleteSurveyButton));
      }
      return /*#__PURE__*/_react["default"].createElement(_Headlight["default"], null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Unarchive"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-info",
        "data-unarchive-survey-button": surveyData.surveyId,
        onClick: _this.unarchiveSurvey
      }, /*#__PURE__*/_react["default"].createElement(_boxRemove["default"], null))), deleteSurveyButton);
    });
    // render flow list (right side)
    _defineProperty(_this, "_renderSurveyList", function () {
      var _this$props3 = _this.props,
        assignment = _this$props3.assignment,
        surveyData = _this$props3.surveyData;

      // just to force the lang order
      var orderedLanguages = ['en', 'es'].filter(function (lang) {
        return assignment.settings.buildLanguages.includes(lang);
      });
      return /*#__PURE__*/_react["default"].createElement("table", {
        className: _styleSurveycard["default"].languages
      }, /*#__PURE__*/_react["default"].createElement("tbody", null, orderedLanguages.map(function (lang) {
        // find the flow that matches the language (if it exists)
        var flowItemData = (0, _find2["default"])(surveyData.flowList, function (flowItem) {
          if (flowItem.language) {
            return flowItem.language.toUpperCase() === lang.toUpperCase();
          }
        });
        var readyForDeploy = assignment.settings.languages.includes(lang);

        // create the row based on the flow's information
        return /*#__PURE__*/_react["default"].createElement("tr", {
          className: _styleSurveycard["default"].languageRow,
          key: lang
        }, _this._renderLanguageRow(lang, flowItemData, readyForDeploy));
      })));
    });
    // render the flow language and "version"
    _defineProperty(_this, "_renderLanguageRow", function (language, flowData, readyForDeploy) {
      var assignment = _this.props.assignment;
      var hasManyLanguages = assignment.settings.buildLanguages.length > 1;
      var deleteFlowTooltip = hasManyLanguages ? "Delete ".concat(_this.getLanguageNameFromTwoLetterCode(language), " version") : 'Delete';
      var isSurveyDeployed = flowData && assignment.deploymentList.some(function (deployment) {
        return deployment.isOpen && deployment.settings.options.includes(flowData.flowHandle);
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _styleSurveycard["default"].editArea
      }, _this._renderSurveyButton(language, flowData)), flowData ? /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: deleteFlowTooltip
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm btn-danger",
        onClick: function onClick() {
          return _this.deleteFlow(language, flowData);
        },
        disabled: readyForDeploy && isSurveyDeployed
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)))) : /*#__PURE__*/_react["default"].createElement("td", null), readyForDeploy && isSurveyDeployed ? /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Used in open data collection wave."
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_styleSurveycard["default"].deployIcon)
      }, /*#__PURE__*/_react["default"].createElement(_podcast["default"], null)))) : /*#__PURE__*/_react["default"].createElement("td", {
        style: {
          paddingRight: 0
        }
      }), flowData && assignment.settings && /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Preview survey",
        size: "large",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-secondary btn-sm"
        }, "Preview")
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, {
        flowId: flowData.flowId,
        isPreviewMode: true,
        onComplete: function onComplete() {}
      }))), flowData ? /*#__PURE__*/_react["default"].createElement("td", {
        className: _styleSurveycard["default"].dateArea
      }, "Last modified:", /*#__PURE__*/_react["default"].createElement("br", null), flowData.updatedAt || '—') : null);
    });
    // render survey button
    _defineProperty(_this, "_renderSurveyButton", function (languageCode, flowData) {
      var _this$props4 = _this.props,
        assignment = _this$props4.assignment,
        project = _this$props4.project;

      // get text/display version of language name
      var langDisplay = assignment.settings.buildLanguages.length > 1 && languageCode !== '' ? ' ' + _this.getLanguageNameFromTwoLetterCode(languageCode) + ' Version' : '';

      // if flow exists
      if (flowData) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          className: "btn btn-sm btn-success",
          to: "/quest/".concat(project.groupId, "/design/flow/").concat(flowData.flowId)
        }, "Edit", langDisplay);
      }

      // if flow does not exist and is not archived
      return _this._renderCreateFlowModal(languageCode, langDisplay);
    });
    _defineProperty(_this, "onCreateFlow", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(languageCode, values) {
        var _this$props5, surveyData, history, project, data, formData, isSuccess, response, flowId, _t5, _t6;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _this$props5 = _this.props, surveyData = _this$props5.surveyData, history = _this$props5.history, project = _this$props5.project;
              data = {
                name: surveyData.label,
                language: languageCode,
                type: 'survey',
                handle: surveyData.surveyHandle,
                settings: {
                  showOneElementPerPage: false,
                  showRequiredState: false,
                  showQuestionNumbers: false,
                  playerTemplate: 'default',
                  playerTemplateSettings: {}
                }
              };
              _t5 = values.createFlow;
              _context7.n = _t5 === 'startWith' ? 1 : _t5 === 'existing' ? 2 : _t5 === 'fromFile' ? 3 : 4;
              break;
            case 1:
              if (values.startWith !== 'none') {
                data.example = values.startWith;
              }
              return _context7.a(3, 5);
            case 2:
              data.existing = values.copyFlowId;
              return _context7.a(3, 5);
            case 3:
              formData = new FormData();
              Object.keys(data).forEach(function (key) {
                formData.append(key, data[key]);
              });
              formData.append('file', values.file);
              data = formData;
              return _context7.a(3, 5);
            case 4:
              throw new Error("Unknown option \"".concat(values.createFlow, "\""));
            case 5:
              _context7.p = 5;
              _context7.n = 6;
              return _this.props.createFlow(data);
            case 6:
              isSuccess = _context7.v;
              if (!isSuccess) {
                _context7.n = 8;
                break;
              }
              _context7.n = 7;
              return _cccisdAxios["default"].get(Boilerplate.route('flow.handle.id', {
                handle: surveyData.surveyHandle,
                language: languageCode
              }));
            case 7:
              response = _context7.v;
              flowId = response.data.flowId;
              (0, _cccisdNotification["default"])("Survey \"".concat(surveyData.label, "\" successfully created"));
              history.push("/quest/".concat(project.groupId, "/design/flow/").concat(flowId));
              _context7.n = 9;
              break;
            case 8:
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "Survey \"".concat(surveyData.label, "\" failed to create")
              });
            case 9:
              _context7.n = 11;
              break;
            case 10:
              _context7.p = 10;
              _t6 = _context7.v;
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: (0, _composeErrorMessage["default"])(_t6),
                duration: 0
              });
              return _context7.a(2, Promise.reject(_t6));
            case 11:
              return _context7.a(2);
          }
        }, _callee7, null, [[5, 10]]);
      }));
      return function (_x5, _x6) {
        return _ref7.apply(this, arguments);
      };
    }());
    // ***** render the "+ Create LANG Version" modal (flow) *****
    _defineProperty(_this, "_renderCreateFlowModal", function (languageCode, langDisplay) {
      var _this$props6 = _this.props,
        project = _this$props6.project,
        assignment = _this$props6.assignment,
        assignmentTerm = _this$props6.assignmentTerm,
        surveyData = _this$props6.surveyData;

      // display text to identify flow language, assignment term, and project name
      var langDisplayVersion = assignment.settings.languages.length > 1 ? _this.getLanguageNameFromTwoLetterCode(languageCode) : '';
      var assignmentProjectLanguageStr = 'For the ' + langDisplayVersion + " version in Survey '" + surveyData.label + "'";
      if (assignment.label !== '') {
        assignmentProjectLanguageStr += ' in ' + assignmentTerm + " '" + assignment.label + "'";
      }
      if (project.label !== '') {
        assignmentProjectLanguageStr += " in Quest Project '" + project.label + "'";
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-primary btn-sm",
          type: "button"
        }, "Create", langDisplay),
        title: "Create the \"".concat(surveyData.label, "\" Survey").concat(langDisplayVersion && " (".concat(langDisplayVersion, ")"))
      }, /*#__PURE__*/_react["default"].createElement(_FlowModalContents["default"], {
        assignmentProjectLanguageStr: assignmentProjectLanguageStr,
        onSubmit: function onSubmit(values) {
          return _this.onCreateFlow(languageCode, values);
        }
      }));
    });
    // get full language name from the two letter code
    _defineProperty(_this, "getLanguageNameFromTwoLetterCode", function (code) {
      switch (code.toUpperCase()) {
        case 'EN':
          return 'English';
        case 'ES':
          return 'Spanish';
        default:
          return '';
      }
    });
    return _this;
  }
  _inherits(SurveyCard, _React$Component);
  return _createClass(SurveyCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props7 = this.props,
        isAssignmentArchived = _this$props7.isAssignmentArchived,
        surveyData = _this$props7.surveyData,
        index = _this$props7.index,
        isDragDisabled = _this$props7.isDragDisabled,
        designFilter = _this$props7.designFilter;
      var isArchived = isAssignmentArchived || surveyData.archived;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, isArchived ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].cardWrapper,
        "data-survey-card": surveyData.surveyId
      }, !isAssignmentArchived && this._renderHeadlight(), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].contentWrapper + ' ' + _styleSurveycard["default"].archived
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].leftSide
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].title
      }, surveyData.label), surveyData.description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].description
      }, surveyData.description)))) : /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "".concat(surveyData.surveyId),
        index: index,
        isDragDisabled: isDragDisabled
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: provided.innerRef
        }, provided.draggableProps, {
          className: _styleSurveycard["default"].cardWrapper,
          "data-survey-card": surveyData.surveyId
        }), _this2._renderHeadlight(), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].contentWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: (0, _classnames2["default"])(_styleSurveycard["default"].dragHandle, _defineProperty({}, _styleSurveycard["default"].disabled, isDragDisabled)),
          "data-survey-card-draggable": surveyData.surveyId
        }, provided.dragHandleProps), /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].leftSide
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].title
        }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
          string: surveyData.label,
          word: designFilter
        })), surveyData.description && /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].description
        }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
          string: surveyData.description,
          word: designFilter
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].divider
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].rightSide
        }, _this2._renderSurveyList())));
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(SurveyCard, "propTypes", {
  index: _propTypes["default"].number,
  project: _propTypes["default"].object,
  assignmentTerm: _propTypes["default"].string,
  assignment: _propTypes["default"].object.isRequired,
  surveyData: _propTypes["default"].object.isRequired,
  isAssignmentArchived: _propTypes["default"].bool,
  updateSurvey: _propTypes["default"].func,
  archiveSurvey: _propTypes["default"].func,
  unarchiveSurvey: _propTypes["default"].func,
  deleteSurvey: _propTypes["default"].func,
  createFlow: _propTypes["default"].func,
  deleteFlow: _propTypes["default"].func,
  isDragDisabled: _propTypes["default"].bool,
  designFilter: _propTypes["default"].string,
  history: _propTypes["default"].object
});
_defineProperty(SurveyCard, "defaultProps", {
  assignmentTerm: 'Assignment'
});
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(null, {
  updateSurvey: _admin.updateSurvey,
  createFlow: _admin.createFlow,
  deleteFlow: _admin.deleteFlow,
  archiveSurvey: _admin.archiveSurvey,
  unarchiveSurvey: _admin.unarchiveSurvey,
  deleteSurvey: _admin.deleteSurvey
})(SurveyCard));